// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactInfoLiteDto
 */
export interface IContactInfoLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IContactInfoLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoLiteDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoLiteDto
     */
    last_name?: string;
}

/**
 * Check if a given object implements the IContactInfoLiteDto interface.
 */
export function instanceOfIContactInfoLiteDto(value: object): value is IContactInfoLiteDto {
    return true;
}

export function IContactInfoLiteDtoFromJSON(json: any): IContactInfoLiteDto {
    return IContactInfoLiteDtoFromJSONTyped(json, false);
}

export function IContactInfoLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactInfoLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function IContactInfoLiteDtoToJSON(json: any): IContactInfoLiteDto {
    return IContactInfoLiteDtoToJSONTyped(json, false);
}

export function IContactInfoLiteDtoToJSONTyped(value?: IContactInfoLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

